'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.constant('EVENTS', {
    loginSuccess: 'LoginSuccess',
    loginFailed: 'LoginFailed',
    logoutSuccess: 'LogoutSuccess',
    refreshAccessToken: 'refreshAccessToken',
    sessionTimeout: 'authSessionTimeout',
    notAuthenticated: 'authNotAuthenticated',
    notAuthorized: 'authNotAuthorized',
    online: 'online',
    offline: 'offline',
    locationSuccess: 'locationSuccess',
    locationChange: 'locationChange',
    locationFailed: 'locationFailed',
    locationGet: 'locationGet',
    appVersionGet: 'appVersionGet'
  });
};

; /**
   * 事件
   */


//////////////////
// WEBPACK FOOTER
// ./src/app/EVENTS.js
// module id = 31
// module chunks = 0